import axios from 'axios';
import { apiUrl } from './config/api';

axios.interceptors.request.use((config) => {
  const requestUrl = config.url || '';
  const isLoginRequest = requestUrl.includes('/api/auth/login');
  if (!isLoginRequest) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';

    const isLoginRequest = requestUrl.includes('/api/auth/login');
    const isMeRequest = requestUrl.includes('/api/auth/me');

    // /me 的 401 由 AuthContext 在启动时处理，避免浏览过程中误登出
    if (status === 401 && !isLoginRequest && !isMeRequest) {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      localStorage.removeItem('actk');
      window.dispatchEvent(new Event('auth:unauthorized'));
    }

    return Promise.reject(error);
  }
);

export default axios;
export { apiUrl };
